import { useCallbackRef, useConstant } from '@talos/kyoko';
import type { GridApi } from 'ag-grid-community';
import { Subject } from 'rxjs';

/**
 * This hook returns a function to be connected to a few AgGrid events. The hook will update an internal width map
 * on every column width change that happens in the blotter. An observable of this width map is returned.
 * The width map is keyed on the column ID.
 */
export const usePricingBlotterColumnWidths = () => {
  const colWidthMapSubject = useConstant(new Subject<Map<string, number>>());
  const colWidthMapObs = useConstant(colWidthMapSubject.asObservable());
  /** All AgGrid events return the api. This is what we use. */
  const syncColWidths = useCallbackRef(({ api }: { api: GridApi | undefined }) => {
    if (!api || api.isDestroyed()) {
      return;
    }

    const widthMap: Map<string, number> = new Map();
    api.getAllGridColumns().forEach(col => widthMap.set(col.getColId(), col.getActualWidth()));
    colWidthMapSubject.next(widthMap);
  });

  return {
    onColumnSizeChange: syncColWidths,
    colWidthMapObs,
  };
};
